module.exports = __webpack_public_path__ + "static/media/Operandum-Platform__Vertical-version_monochromatic_no-subtitle.fd163f07.png";